/* eslint-disable */
/**
 * Generated `api` utility.
 *
 * THIS CODE IS AUTOMATICALLY GENERATED.
 *
 * To regenerate, run `npx convex dev`.
 * @module
 */

import type * as accessGrants from "../accessGrants.js";
import type * as admins from "../admins.js";
import type * as ai from "../ai.js";
import type * as anchorReviews from "../anchorReviews.js";
import type * as anchorSnapshots from "../anchorSnapshots.js";
import type * as anchors from "../anchors.js";
import type * as bookmarks from "../bookmarks.js";
import type * as chapterTitle from "../chapterTitle.js";
import type * as checkout from "../checkout.js";
import type * as classroom from "../classroom.js";
import type * as contextLinks from "../contextLinks.js";
import type * as conversionUpload from "../conversionUpload.js";
import type * as conversions from "../conversions.js";
import type * as crons from "../crons.js";
import type * as dataMigration from "../dataMigration.js";
import type * as engagement from "../engagement.js";
import type * as glossStats from "../glossStats.js";
import type * as lib_access from "../lib/access.js";
import type * as lib_boundedFetch from "../lib/boundedFetch.js";
import type * as lib_checkoutClient from "../lib/checkoutClient.js";
import type * as lib_clock from "../lib/clock.js";
import type * as lib_entitlements from "../lib/entitlements.js";
import type * as lib_env from "../lib/env.js";
import type * as lib_googleAccessToken from "../lib/googleAccessToken.js";
import type * as lib_logEvent from "../lib/logEvent.js";
import type * as lib_pricing from "../lib/pricing.js";
import type * as lib_subscriptions from "../lib/subscriptions.js";
import type * as lib_unitMeasure from "../lib/unitMeasure.js";
import type * as matter from "../matter.js";
import type * as matterPendingEdits from "../matterPendingEdits.js";
import type * as migrations from "../migrations.js";
import type * as model_accessGrant from "../model/accessGrant.js";
import type * as model_acquisitionStats from "../model/acquisitionStats.js";
import type * as model_adminRole from "../model/adminRole.js";
import type * as model_anchor from "../model/anchor.js";
import type * as model_anchorInvariants from "../model/anchorInvariants.js";
import type * as model_anchorReview from "../model/anchorReview.js";
import type * as model_anchorSnapshot from "../model/anchorSnapshot.js";
import type * as model_anchoredExport from "../model/anchoredExport.js";
import type * as model_applyEdits from "../model/applyEdits.js";
import type * as model_attribution from "../model/attribution.js";
import type * as model_block from "../model/block.js";
import type * as model_blockEdit from "../model/blockEdit.js";
import type * as model_blockId from "../model/blockId.js";
import type * as model_blockMarkdown from "../model/blockMarkdown.js";
import type * as model_bookConfig from "../model/bookConfig.js";
import type * as model_bookmark from "../model/bookmark.js";
import type * as model_bookmarkMerge from "../model/bookmarkMerge.js";
import type * as model_checkoutOrder from "../model/checkoutOrder.js";
import type * as model_classroomConversion from "../model/classroomConversion.js";
import type * as model_classroomInquiry from "../model/classroomInquiry.js";
import type * as model_contextExcerpt from "../model/contextExcerpt.js";
import type * as model_contextLink from "../model/contextLink.js";
import type * as model_conversionUpload from "../model/conversionUpload.js";
import type * as model_dataManagerEvent from "../model/dataManagerEvent.js";
import type * as model_describe from "../model/describe.js";
import type * as model_engagementTier from "../model/engagementTier.js";
import type * as model_engagementUpload from "../model/engagementUpload.js";
import type * as model_entitlement from "../model/entitlement.js";
import type * as model_gloss from "../model/gloss.js";
import type * as model_glossInput from "../model/glossInput.js";
import type * as model_googleServiceAccount from "../model/googleServiceAccount.js";
import type * as model_language from "../model/language.js";
import type * as model_location from "../model/location.js";
import type * as model_logEvent from "../model/logEvent.js";
import type * as model_matterMarkdown from "../model/matterMarkdown.js";
import type * as model_matterPendingEdit from "../model/matterPendingEdit.js";
import type * as model_paidAccessAudit from "../model/paidAccessAudit.js";
import type * as model_pendingEdit from "../model/pendingEdit.js";
import type * as model_planCatalog from "../model/planCatalog.js";
import type * as model_premiumAccess from "../model/premiumAccess.js";
import type * as model_pricing from "../model/pricing.js";
import type * as model_productCatalog from "../model/productCatalog.js";
import type * as model_publishPlan from "../model/publishPlan.js";
import type * as model_readMark from "../model/readMark.js";
import type * as model_readingCohort from "../model/readingCohort.js";
import type * as model_readingProgress from "../model/readingProgress.js";
import type * as model_readingStats from "../model/readingStats.js";
import type * as model_receipt from "../model/receipt.js";
import type * as model_receiptShape from "../model/receiptShape.js";
import type * as model_receiptVerify from "../model/receiptVerify.js";
import type * as model_renumberBlocks from "../model/renumberBlocks.js";
import type * as model_retellingMarkdown from "../model/retellingMarkdown.js";
import type * as model_returnOrigin from "../model/returnOrigin.js";
import type * as model_selection from "../model/selection.js";
import type * as model_session from "../model/session.js";
import type * as model_shelfOrder from "../model/shelfOrder.js";
import type * as model_subscriptionAccess from "../model/subscriptionAccess.js";
import type * as model_subscriptionConversionValue from "../model/subscriptionConversionValue.js";
import type * as model_subscriptionReceipt from "../model/subscriptionReceipt.js";
import type * as model_tokenUsage from "../model/tokenUsage.js";
import type * as model_translationQuota from "../model/translationQuota.js";
import type * as model_unitOrder from "../model/unitOrder.js";
import type * as model_volume from "../model/volume.js";
import type * as model_wordGloss from "../model/wordGloss.js";
import type * as pendingEdits from "../pendingEdits.js";
import type * as premium from "../premium.js";
import type * as pricing from "../pricing.js";
import type * as publish from "../publish.js";
import type * as readMarks from "../readMarks.js";
import type * as reading from "../reading.js";
import type * as retell from "../retell.js";
import type * as seed from "../seed.js";
import type * as shelf from "../shelf.js";
import type * as stats from "../stats.js";
import type * as subscriptions from "../subscriptions.js";

import type {
  ApiFromModules,
  FilterApi,
  FunctionReference,
} from "convex/server";
import { anyApi, componentsGeneric } from "convex/server";

const fullApi: ApiFromModules<{
  accessGrants: typeof accessGrants;
  admins: typeof admins;
  ai: typeof ai;
  anchorReviews: typeof anchorReviews;
  anchorSnapshots: typeof anchorSnapshots;
  anchors: typeof anchors;
  bookmarks: typeof bookmarks;
  chapterTitle: typeof chapterTitle;
  checkout: typeof checkout;
  classroom: typeof classroom;
  contextLinks: typeof contextLinks;
  conversionUpload: typeof conversionUpload;
  conversions: typeof conversions;
  crons: typeof crons;
  dataMigration: typeof dataMigration;
  engagement: typeof engagement;
  glossStats: typeof glossStats;
  "lib/access": typeof lib_access;
  "lib/boundedFetch": typeof lib_boundedFetch;
  "lib/checkoutClient": typeof lib_checkoutClient;
  "lib/clock": typeof lib_clock;
  "lib/entitlements": typeof lib_entitlements;
  "lib/env": typeof lib_env;
  "lib/googleAccessToken": typeof lib_googleAccessToken;
  "lib/logEvent": typeof lib_logEvent;
  "lib/pricing": typeof lib_pricing;
  "lib/subscriptions": typeof lib_subscriptions;
  "lib/unitMeasure": typeof lib_unitMeasure;
  matter: typeof matter;
  matterPendingEdits: typeof matterPendingEdits;
  migrations: typeof migrations;
  "model/accessGrant": typeof model_accessGrant;
  "model/acquisitionStats": typeof model_acquisitionStats;
  "model/adminRole": typeof model_adminRole;
  "model/anchor": typeof model_anchor;
  "model/anchorInvariants": typeof model_anchorInvariants;
  "model/anchorReview": typeof model_anchorReview;
  "model/anchorSnapshot": typeof model_anchorSnapshot;
  "model/anchoredExport": typeof model_anchoredExport;
  "model/applyEdits": typeof model_applyEdits;
  "model/attribution": typeof model_attribution;
  "model/block": typeof model_block;
  "model/blockEdit": typeof model_blockEdit;
  "model/blockId": typeof model_blockId;
  "model/blockMarkdown": typeof model_blockMarkdown;
  "model/bookConfig": typeof model_bookConfig;
  "model/bookmark": typeof model_bookmark;
  "model/bookmarkMerge": typeof model_bookmarkMerge;
  "model/checkoutOrder": typeof model_checkoutOrder;
  "model/classroomConversion": typeof model_classroomConversion;
  "model/classroomInquiry": typeof model_classroomInquiry;
  "model/contextExcerpt": typeof model_contextExcerpt;
  "model/contextLink": typeof model_contextLink;
  "model/conversionUpload": typeof model_conversionUpload;
  "model/dataManagerEvent": typeof model_dataManagerEvent;
  "model/describe": typeof model_describe;
  "model/engagementTier": typeof model_engagementTier;
  "model/engagementUpload": typeof model_engagementUpload;
  "model/entitlement": typeof model_entitlement;
  "model/gloss": typeof model_gloss;
  "model/glossInput": typeof model_glossInput;
  "model/googleServiceAccount": typeof model_googleServiceAccount;
  "model/language": typeof model_language;
  "model/location": typeof model_location;
  "model/logEvent": typeof model_logEvent;
  "model/matterMarkdown": typeof model_matterMarkdown;
  "model/matterPendingEdit": typeof model_matterPendingEdit;
  "model/paidAccessAudit": typeof model_paidAccessAudit;
  "model/pendingEdit": typeof model_pendingEdit;
  "model/planCatalog": typeof model_planCatalog;
  "model/premiumAccess": typeof model_premiumAccess;
  "model/pricing": typeof model_pricing;
  "model/productCatalog": typeof model_productCatalog;
  "model/publishPlan": typeof model_publishPlan;
  "model/readMark": typeof model_readMark;
  "model/readingCohort": typeof model_readingCohort;
  "model/readingProgress": typeof model_readingProgress;
  "model/readingStats": typeof model_readingStats;
  "model/receipt": typeof model_receipt;
  "model/receiptShape": typeof model_receiptShape;
  "model/receiptVerify": typeof model_receiptVerify;
  "model/renumberBlocks": typeof model_renumberBlocks;
  "model/retellingMarkdown": typeof model_retellingMarkdown;
  "model/returnOrigin": typeof model_returnOrigin;
  "model/selection": typeof model_selection;
  "model/session": typeof model_session;
  "model/shelfOrder": typeof model_shelfOrder;
  "model/subscriptionAccess": typeof model_subscriptionAccess;
  "model/subscriptionConversionValue": typeof model_subscriptionConversionValue;
  "model/subscriptionReceipt": typeof model_subscriptionReceipt;
  "model/tokenUsage": typeof model_tokenUsage;
  "model/translationQuota": typeof model_translationQuota;
  "model/unitOrder": typeof model_unitOrder;
  "model/volume": typeof model_volume;
  "model/wordGloss": typeof model_wordGloss;
  pendingEdits: typeof pendingEdits;
  premium: typeof premium;
  pricing: typeof pricing;
  publish: typeof publish;
  readMarks: typeof readMarks;
  reading: typeof reading;
  retell: typeof retell;
  seed: typeof seed;
  shelf: typeof shelf;
  stats: typeof stats;
  subscriptions: typeof subscriptions;
}> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's public API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = api.myModule.myFunction;
 * ```
 */
export const api: FilterApi<
  typeof fullApi,
  FunctionReference<any, "public">
> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's internal API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = internal.myModule.myFunction;
 * ```
 */
export const internal: FilterApi<
  typeof fullApi,
  FunctionReference<any, "internal">
> = anyApi as any;

export const components = componentsGeneric() as unknown as {};
